import { useCallback, useState } from "react";
import QuerySubmitSuccessBody from "../components/QuerySubmitSuccessBody";

export function useSubmitQuery({ bridge, categoryId, classes, fileName }) {
  const [waiting, setWaiting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState('');

  const closeModal = useCallback(() => setShowModal(false), []);

  const submitQuery = useCallback(
    async (queryObj) => {
      setWaiting(true);

      try {
        const result = await bridge.startJob({
          categoryId,
          definition: queryObj,
        });

        const { ok, status, body } = result;
        const queryId = body?.id;
        

        // Prefer checking status first, then ok
        if (status === 409) {
          setModalData({
            header: "Warning",
            body: body?.message || "Duplicate query detected",
          });
        } else if (!ok) {
          setModalData({
            header: "Error",
            body: body?.message || "Query submission error",
          });
        } else if (status >= 200 && status < 300) {
          setModalData({
            header: "Your Query Is Ready to Process",
            body: queryId ? (
              <QuerySubmitSuccessBody
                classes={classes}
                fileName={fileName}
                queryId={queryId}
              />
            ) : (
              ""
            ),
          });
        } else {
          setModalData({
            header: "Warning",
            body: "Issue with query submission",
          });
        }

        setShowModal(true);
        return result;
      } catch (e) {
        // Show a useful error modal
        setModalData({
          header: "Error",
          body: e?.message || "Something went wrong while submitting the query.",
        });
        setShowModal(true);
        throw e; // optional: remove if you don't want caller catch
      } finally {
        setWaiting(false);
      }
    },
    [bridge, categoryId, classes, fileName]
  );

  return {
    submitQuery,
    waiting,
    showModal,
    modalData,
    closeModal,
    setShowModal,
    setModalData,
  };
}